import React, { useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from "formik";
import TextField from "@material-ui/core/TextField";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import * as Yup from "yup";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import { themeButtons } from "../../css/themeButtons";
import { Button } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { useHistory } from "react-router-dom";
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const phoneRegExp = /^[\d\s\+\(\)\-]+$/gi;

export const confirmMessageWithType = {
  'email': 'Вам отправлено письмо на Email, для подтверждения аккаунта перейдите по ссылке из письма',
  'WHATSAPP': 'Вам отправлено сообщение на WhatsApp, для подтверждения аккаунта перейдите по ссылке из сообщение',
  'VIBER': 'Вам отправлено сообщение на Viber, для подтверждения аккаунта перейдите по ссылке из сообщение',
};

const UserSettings = (props) => {
  const { user, saveUser, getMessengersList, messengers, sendUserConfirmation, updatedPass } = props

  const [confirmMessage, setConfirmMassage] = useState()
  const [targetRedirectLink, setTargetRedirectLink] = useState(false)

  const history = useHistory()

  //видимость символов пароля
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (!messengers) {
      getMessengersList()
    }
  }, [getMessengersList, messengers])


  //валидация

  const ProfileSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/\S/, 'Имя не может быть пустым')
      .required('Имя не может быть пустым'),
    password: Yup.string()
      .min(6, 'Пароль должен быть не меньше 6 символов'),
    passwordRepeat: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Не совпадает с новым паролем')
      .when('password', {
        is: (password) => !!password,
        then: Yup.string()
          .required('Обязательно для заполнения'),
        otherwise: Yup.string().nullable(),
      }),
    personalMobile: Yup.string()
      .matches(phoneRegExp, 'Не корректный телефон')
      .min(11, 'Не корректный телефон')
      .max(24, 'Не корректный телефон'),

    email: Yup.string()
      .email('Некорректный Email'),
  });


  const formRef = useRef()

  //сохранение страницы
  const onSubmit = async (values) => {

    if (formRef.current) {
      formRef.current.resetForm()
    }

    let response = await saveUser({ object: user.id, data: values })

    if (response) {
      if (response === "logout") {

        setTimeout(() => {
          updatedPass()
        }, 1250)

      }

      if (targetRedirectLink) {
        history.push(targetRedirectLink)
      }
    }
  }


  const confirmContact = async (type) => {
    if (type) {
      setConfirmMassage(confirmMessageWithType[type])
      sendUserConfirmation({ type })
    }
  }

  const buttons = themeButtons()

  return (
    <div className="main">
      <div className="container-fluid">
        {confirmMessage && <div className="col-md-8">
          <Box className="alert alert-success">
            {confirmMessage}
          </Box>
        </div>}
        <Formik enableReinitialize
                innerRef={formRef}
                validationSchema={ProfileSchema}
                initialValues={{
                  lastName: user?.lastName || "",
                  name: user?.name || "",
                  secondName: user?.secondName || "",
                  position: user?.position || "",
                  personalMobile: user?.personalMobile || "",
                  email: user?.email || "",
                  password: "",
                  passwordRepeat: "",
                  messenger: user?.messenger || ""
                }}
                onSubmit={onSubmit}>
          {({ values, errors, touched, dirty, handleSubmit }) => (
            <Form>

              <div className="row">
                <div className="col-md-8">
                  <div className="mb-5">
                    <h5 className="mb-3">Профиль</h5>
                    <div className="row mb-3 g-3">
                      <div className="col-lg-4">
                        <Field name="lastName">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Фамилия"
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Field>

                      </div>
                      <div className="col-lg-4">
                        <Field name="name">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Имя"
                              fullWidth
                              size="small"
                              variant="outlined"
                              error={touched.name && errors.name}
                              helperText={touched.name && errors.name && errors.name}
                            />
                          )}
                        </Field>

                      </div>
                      <div className="col-lg-4">
                        <Field name="secondName">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Отчество"
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Field>

                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg">
                        <Field name="position">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Должность"
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="row mb-3 g-3 align-items-center">
                      <div className="col">
                        <Field name="personalMobile">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Телефон"
                              fullWidth
                              disabled={user.login === user.personalMobile}
                              size="small"
                              variant="outlined"
                              error={Boolean(errors.personalMobile && touched.personalMobile)}
                              helperText={
                                errors.personalMobile &&
                                touched.personalMobile &&
                                String(errors.personalMobile)
                              }
                            />
                          )}
                        </Field>
                      </div>
                      <div className="col-lg-4">
                        <Field name="messenger">
                          {({ field }) => (
                            <FormControl variant="outlined" size="small" fullWidth>
                              <InputLabel>Мессенджер</InputLabel>
                              <Select
                                label="Мессенджер"
                                {...field}
                              >
                                {messengers && Object.keys(messengers).map(msg => {
                                  return <MenuItem key={msg} value={msg}>
                                    {messengers[msg]}
                                  </MenuItem>
                                })}


                              </Select>
                            </FormControl>
                          )}
                        </Field>
                      </div>

                      {(values.messenger !== '' && user.messenger && user.verified !== 'Y') &&
                        <div className="col-lg-4">
                          <Button onClick={() => confirmContact("phone")}
                                  disabled={Boolean(confirmMessage)}
                                  className={`btn w-100 px-1 ${buttons.btnGreen}`}>Подтвердить
                            по {messengers && messengers[user.messenger]}</Button>
                        </div>}
                    </div>


                    <div className="row g-3 align-items-center">
                      <div className="col">
                        <Field name="email">
                          {({ field }) => (
                            <TextField
                              {...field}
                              disabled={user.login === user.email}
                              label="Почта"
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Field>
                      </div>
                      {(values.email !== '' && user.email && user.verified !== 'Y') &&
                        <div className="col-lg-4">
                          <Button onClick={() => confirmContact("email")}
                                  disabled={Boolean(confirmMessage)}
                                  className={`btn w-100 px-1 ${buttons.btnGreen}`}>Подтвердить по
                            Email</Button>
                        </div>}

                    </div>

                  </div>

                  <div>
                    <h5 className="mb-3">Сменить пароль</h5>

                    <div className="row mb-3 g-3">
                      <div className="col-sm-6">
                        <Field name="password">
                          {({ field }) => (
                            <FormControl fullWidth size="small" variant="outlined"
                                         error={Boolean(errors.password && touched.password)}>
                              <InputLabel
                                htmlFor="outlined-adornment-password">Пароль</InputLabel>
                              <OutlinedInput
                                {...field}
                                type={showPassword ? "text" : "password"}
                                label="Пароль"
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={toggleShowPassword}
                                      edge="end"
                                    >
                                      {showPassword ? <Visibility/> :
                                        <VisibilityOff/>}
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={70}
                              />
                              {errors.password && touched.password
                                ?
                                <FormHelperText>{errors.password && touched.password && String(errors.password)}</FormHelperText>
                                : null}
                            </FormControl>
                          )}
                        </Field>
                      </div>
                      <div className="col-sm-6">
                        <Field name="passwordRepeat">
                          {({ field }) => (
                            <FormControl fullWidth size="small" variant="outlined"
                                         error={Boolean(errors.passwordRepeat)}>
                              <InputLabel
                                htmlFor="outlined-adornment-password">Повторите
                                пароль</InputLabel>
                              <OutlinedInput
                                {...field}
                                type={showPassword ? "text" : "password"}
                                label="Повторите пароль"
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={toggleShowPassword}
                                      edge="end"
                                    >
                                      {showPassword ? <Visibility/> :
                                        <VisibilityOff/>}
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={70}
                              />
                              {errors.passwordRepeat
                                ?
                                <FormHelperText>{errors.passwordRepeat && String(errors.passwordRepeat)}</FormHelperText>
                                : null}
                            </FormControl>

                          )}
                        </Field>
                      </div>

                    </div>


                  </div>

                </div>
              </div>


              {dirty && Object.keys(errors).length === 0 && <StickyBottomButton action={handleSubmit}/>}

              <AlertSavePage unsavedPage={dirty && Object.keys(errors).length === 0}
                             btnOkAction={handleSubmit}
                             setTargetRedirectLink={setTargetRedirectLink}
                             targetRedirectLink={targetRedirectLink}/>

            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}


export default UserSettings;
